// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CommonUtils$PorterinUtils from "../utils/CommonUtils.mjs";
import * as CookieHelpers$PorterinUtils from "../helpers/CookieHelpers.mjs";
import * as PageviewAnalyticsConfig$PorterinUtils from "./PageviewAnalyticsConfig.mjs";

function makePayload(params, locale) {
  return {
          page_url: window.location.href,
          web_tracking_id: CookieHelpers$PorterinUtils.webTrackingIdSafely(undefined),
          user_agent: window.navigator.userAgent,
          triggered_at: CommonUtils$PorterinUtils.getCurrentTime(PageviewAnalyticsConfig$PorterinUtils.timeFormat),
          published_at: CommonUtils$PorterinUtils.getCurrentTime(PageviewAnalyticsConfig$PorterinUtils.timeFormat),
          utm_source: CommonUtils$PorterinUtils.extractParam(PageviewAnalyticsConfig$PorterinUtils.utm_source, params),
          utm_term: CommonUtils$PorterinUtils.extractParam(PageviewAnalyticsConfig$PorterinUtils.utm_term, params),
          utm_campaign: CommonUtils$PorterinUtils.extractParam(PageviewAnalyticsConfig$PorterinUtils.utm_campaign, params),
          utm_content: CommonUtils$PorterinUtils.extractParam(PageviewAnalyticsConfig$PorterinUtils.utm_content, params),
          utm_medium: CommonUtils$PorterinUtils.extractParam(PageviewAnalyticsConfig$PorterinUtils.utm_medium, params),
          country: PageviewAnalyticsConfig$PorterinUtils.countryForLocale(locale)
        };
}

export {
  makePayload ,
}
/* CommonUtils-PorterinUtils Not a pure module */
